import { Spinner } from "../../../components/Spinner/Spinner.tsx";
import { useAppQuery } from "../../../http/useAppQuery.ts";
import { PricingTable } from "../../components/UpgradeDialog/PricingTable.tsx";
import { useUser } from "../../hooks/useUser.ts";
import type { Workspace, WorkspaceDetails } from "../../types.ts";
import { PLAN_SELECTION_STEP } from "../constants.ts";
import { UserOnboardingLayout } from "./UserOnboardingLayout.tsx";

export const PlanSelectionOnboardingForm = ({
  onComplete,
  onSubscriptionCheckoutRedirection,
}: {
  onComplete: () => void;
  onSubscriptionCheckoutRedirection: () => void;
}) => {
  const { user } = useUser();
  const workspaceUuid = user?.workspaces[0].uuid;
  const { data: workspace } = useAppQuery<Workspace>({
    queryKey: `workspaces/${workspaceUuid ?? ""}`,
    enabled: !!workspaceUuid,
  });
  const { data: workspaceDetails } = useAppQuery<WorkspaceDetails>({
    queryKey: `workspaces/${workspaceUuid ?? ""}/details`,
    enabled: !!workspaceUuid,
  });

  return workspace && workspaceDetails ? (
    <UserOnboardingLayout
      title="Select your plan"
      step={PLAN_SELECTION_STEP}
      progress={0.8}
      onSkip={onComplete}
    >
      <PricingTable
        workspace={workspace}
        workspaceDetails={workspaceDetails}
        highlight={{ type: "team", label: "Most popular" }}
        onSubscriptionCheckoutUrlCreation={onSubscriptionCheckoutRedirection}
      />
    </UserOnboardingLayout>
  ) : (
    <Spinner />
  );
};
